<template>

   <div class="col-xl-4 col-lg-3 col-md-6 col-sm-6 col-6">
      <div class="productCard">
         <div class="productThumbBrink-lightBlue">
            <img class="img-fluid" :title="imgProductDescription" :src="imgSource"/>
         </div>
         <div class="productContent">
            <a href="#" v-on:click="addProductToOrder"> {{product.product_name}} </a>
         </div>
      </div>
   </div>
   
</template>

<script>

import {Product} from "../../classes/product"

export default {
  name: "ProductCard",
  props: {
    //img: String,
    //title: String,
    product: Product
  },
  data() {
    return {
      
    }
  },
  computed: {
   imgSource(){

      var imageProduct = "otro";

      switch (this.product.product_type) {
         case 'TIEMPO BRINCOLIN':
            imageProduct = "trampolin";
            break;
         case 'TIEMPO TREN':
            imageProduct = "tren";
            break;
         case 'TIEMPO CABALLITOS':
            imageProduct = "caballito";
            break;
         case 'TIEMPO CARRITOS':
            imageProduct = "carrito";
            break;
         case 'TIEMPO MODULAR':
            imageProduct = "dona";
            break;
         case 'DULCERIA':
            imageProduct = "snack";
            break;
         case 'OTROS':
            imageProduct = "otro";
            break;
         case 'CALCETAS':
            imageProduct = "socks";
            break;
         case 'TIEMPO LIBRE':
            imageProduct = "freeTime";
            break;
         case 'ARTICULO COVID':
            imageProduct = "covid";
            break;
         }

      return require('@assets/images/products/'+imageProduct+'.png')
   },
   imgProductDescription(){
      return this.product.product_description;
   }

  },
  methods: {
     async addProductToOrder(){
      await this.$emit('on-product-action', this.product);
     }

  },
};
</script>

<style>
</style>